import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductsFacade } from '@ridango/components';
import { AppStartupService, PaymentDataService, Product, PaymentType } from '@ridango/core';
import { WalletTopUpModalComponent } from '@ridango/widgets';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-wallet-loading-page-v2-select-amount',
    templateUrl: './select-amount.component.html'
})
export class WalletLoadingPageV2SelectAmountComponent implements OnInit {
    allWalletProducts$: Observable<Product[]>;
    filteredWalletProducts$: Observable<Product[]>;
    manualPriceProduct$: Observable<Product | null>;
    manualPriceProduct: Product | null = null;
    selectedProduct: Product;
    selectedProductId: number;
    selectedAmount: number;
    currencySymbol: string;
    locale = this.translate.currentLang;

    @ViewChild('walletTopUpModal') walletTopUpModal: WalletTopUpModalComponent;

    constructor(
        private productsFacade: ProductsFacade,
        public appStartupService: AppStartupService,
        private translate: TranslateService,
        private paymentData: PaymentDataService,
        @Inject('ENV') public env: Env
    ) {}

    ngOnInit(): void {
        this.productsFacade.fetchWalletProducts();
        this.currencySymbol = this.appStartupService.getCurrencySymbol();

        this.allWalletProducts$ = this.productsFacade.products$.pipe(
            map((products) => products.filter((product) => product.product_type === PaymentType.WALLET))
        );

        this.filteredWalletProducts$ = this.allWalletProducts$.pipe(
            map((products) =>
                products.filter((product) => !product.product_properties.some((prop) => prop.code === 'MANUAL_PRICE'))
            )
        );

        this.manualPriceProduct$ = this.allWalletProducts$.pipe(
            map(
                (products) =>
                    products.find((product) =>
                        product.product_properties.some((prop) => prop.code === 'MANUAL_PRICE')
                    ) || null
            )
        );

        this.manualPriceProduct$.subscribe((product) => (this.manualPriceProduct = product));

        const product = this.paymentData.getProduct();
        if (product) {
            if (product.product_id === null && product.price) {
                this.selectedAmount = product.price;
            } else {
                this.selectedProduct = product;
            }
        }
    }

    selectProduct(product: Product): void {
        this.selectedProduct = product;
        this.selectedProductId = product.product_id;
        this.paymentData.setProduct(product);
        this.selectedAmount = null;
    }

    handleAmountSelected(amount: number): void {
        const customProduct = {
            product_id: this.manualPriceProduct?.product_id,
            price: amount
        };

        this.selectedAmount = amount;
        this.paymentData.setProduct(customProduct);
        this.selectedProduct = null;
        this.selectedProductId = null;
    }

    selectCustomProduct(): void {
        this.walletTopUpModal.manualPriceProduct = this.manualPriceProduct;
        this.walletTopUpModal.openModal();
    }
}
